import { createWebHistory, createRouter } from "vue-router";
import store from "../store";
import { matchMenu } from "../utils/menu-context";
import { setIsLoading, state as stateApp, clearModal } from "../app.logic";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

const RouteView = {
    render: () => <router-view></router-view>
};

const routeData = [
    {
        path: "",
        name: "index",
        redirect: { name: "app" }
    },
    {
        path: "/app",
        name: "app",
        redirect: { name: "home" },
        component: () => import("../components/layout/app-layout/AppLayout"),
        children: [
            {
                path: "home",
                name: "home",
                component: () => import("../views/app/home/Home")
            },
            {
                path: "profile",
                redirect: { name: "profile" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "profile",
                        component: () => import("../views/app/profile/ProfileForm")
                    }
                ]
            },
            {
                path: "notifications",
                redirect: { name: "notifications" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "notifications",
                        component: () => import("../views/app/notification/NotificationList")
                    }
                ]
            },
            {
                path: "data-mgt",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "data-mgt",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "departments",
                        redirect: { name: "departments" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "departments",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentList")
                            },
                            {
                                path: "create",
                                name: "departments-create",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "departments-edit",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm")
                            },
                            {
                                path: ":id/view",
                                name: "departments-view",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "lookups",
                        redirect: { name: "lookups" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lookups",
                                component: () => import("../views/app/setting/data-mgt/lookup/LookupIconList")
                            },
                            {
                                path: ":group",
                                component: {
                                    render: () => <router-view></router-view>,
                                    setup() {
                                        const route = useRoute();
                                        const { createGroupTitle } = require("../views/app/setting/data-mgt/lookup/lookup.logic");
                                        const group = route.params.group;
                                        const title = computed(() => createGroupTitle({ group }));
                                        return { title };
                                    }
                                },
                                children: [
                                    {
                                        path: "",
                                        name: "lookups-group",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupList")
                                    },
                                    {
                                        path: "create",
                                        name: "lookups-create",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "lookups-edit",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "lookups-view",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: "events",
                redirect: { name: "events" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "events",
                        component: () => import("../views/app/event/EventList")
                    },
                    {
                        path: ":id/view",
                        name: "events-view",
                        component: () => import("../views/app/event/EventForm"),
                        props: { viewOnly: true }
                    }
                ]
            },
            {
                path: "security-events",
                redirect: { name: "security-events" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "security-events",
                        component: () => import("../views/app/security-event/SecurityEventList")
                    },
                    {
                        path: ":id/view",
                        name: "security-events-view",
                        component: () => import("../views/app/security-event/SecurityEventForm"),
                        props: { viewOnly: true }
                    }
                ]
            },
            {
                path: "setting",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "setting",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "user-mgt",
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "user-mgt",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true }
                            },
                            {
                                path: "users",
                                redirect: { name: "users" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "users",
                                        component: () => import("../views/app/setting/user-mgt/user/UserList")
                                    },
                                    {
                                        path: "create",
                                        name: "users-create",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "users-edit",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "users-view",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            },
                            {
                                path: "roles",
                                redirect: { name: "roles" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "roles",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleList")
                                    },
                                    {
                                        path: "create",
                                        name: "roles-create",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "roles-edit",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "roles-view",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            },
                            {
                                path: "resources",
                                redirect: { name: "resources" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "resources",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceList")
                                    },
                                    {
                                        path: "create",
                                        name: "resources-create",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "resources-edit",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "resources-view",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            },
                            {
                                path: "menus",
                                redirect: { name: "menus" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "menus",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuList")
                                    },
                                    {
                                        path: "create",
                                        name: "menus-create",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "menus-edit",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "menus-view",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            },
                            {
                                path: "user-company-manages",
                                redirect: { name: "user-company-manages" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "user-company-manages",
                                        component: () => import("../views/app/setting/user-mgt/user-company-manage/UserCompanyManageList")
                                    },
                                    {
                                        path: "create",
                                        name: "user-company-manages-create",
                                        component: () => import("../views/app/setting/user-mgt/user-company-manage/UserCompanyManageForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "user-company-manages-edit",
                                        component: () => import("../views/app/setting/user-mgt/user-company-manage/UserCompanyManageForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "user-company-manages-view",
                                        component: () => import("../views/app/setting/user-mgt/user-company-manage/UserCompanyManageForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "menu-sides",
                        redirect: { name: "menu-sides" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "menu-sides",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideList")
                            },
                            {
                                path: "create",
                                name: "menu-sides-create",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "menu-sides-edit",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm")
                            },
                            {
                                path: ":id/view",
                                name: "menu-sides-view",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "application",
                        redirect: { name: "application" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "application",
                                component: () => import("../views/app/setting/application/Application")
                            }
                        ]
                    }
                ]
            },
            {
                path: "company",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "company",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "companies",
                        redirect: { name: "companies" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "companies",
                                component: () => import("../views/app/company/user-company/UserCompanyList")
                            },
                            {
                                path: "create",
                                name: "companies-create",
                                component: () => import("../views/app/company/user-company/UserCompanyForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "companies-edit",
                                component: () => import("../views/app/company/user-company/UserCompanyForm")
                            },
                            {
                                path: ":id/view",
                                name: "companies-view",
                                component: () => import("../views/app/company/user-company/UserCompanyForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "company-requests",
                        redirect: { name: "company-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "company-requests",
                                component: () => import("../views/app/company/company-request/CompanyRequestList")
                            },
                            {
                                path: "create",
                                name: "company-requests-create",
                                component: () => import("../views/app/company/company-request/CompanyRequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "company-requests-edit",
                                component: () => import("../views/app/company/company-request/CompanyRequestForm")
                            },
                            {
                                path: ":id/view",
                                name: "company-requests-view",
                                component: () => import("../views/app/company/company-request/CompanyRequestForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "investigations",
                        redirect: { name: "investigations" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "investigations",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectList"),
                                props: { routerPrefix: "investigations" }
                            },
                            {
                                path: "create",
                                name: "investigations-create",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: route => ({ routerPrefix: "investigations", ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "investigations-edit",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: { routerPrefix: "investigations" }
                            },
                            {
                                path: ":id/view",
                                name: "investigations-view",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: { viewOnly: true, routerPrefix: "investigations" }
                            }
                        ]
                    },
                    {
                        path: "follow-up-rejects",
                        redirect: { name: "follow-up-rejects" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "follow-up-rejects",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectList"),
                                props: { routerPrefix: "follow-up-rejects" }
                            },
                            {
                                path: "create",
                                name: "follow-up-rejects-create",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: route => ({ routerPrefix: "follow-up-rejects", ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "follow-up-rejects-edit",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: { routerPrefix: "follow-up-rejects" }
                            },
                            {
                                path: ":id/view",
                                name: "follow-up-rejects-view",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: { viewOnly: true, routerPrefix: "follow-up-rejects" }
                            }
                        ]
                    },
                    {
                        path: "company-doc-rejects",
                        redirect: { name: "follow-up-rejects" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "company-doc-rejects",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectList"),
                                props: { routerPrefix: "company-doc-rejects" }
                            },
                            {
                                path: "create",
                                name: "company-doc-rejects-create",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: route => ({ routerPrefix: "company-doc-rejects", ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "company-doc-rejects-edit",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: { routerPrefix: "company-doc-rejects" }
                            },
                            {
                                path: ":id/view",
                                name: "company-doc-rejects-view",
                                component: () => import("../views/app/company/company-doc-reject/CompanyDocRejectForm"),
                                props: { viewOnly: true, routerPrefix: "company-doc-rejects" }
                            }
                        ]
                    },
                    {
                        path: "company-calendars",
                        redirect: { name: "company-calendars" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "company-calendars",
                                component: () => import("../views/app/company/company-calendar/CompanyCalendarList")
                            },
                            {
                                path: "create",
                                name: "company-calendars-create",
                                component: () => import("../views/app/company/company-calendar/CompanyCalendarForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "company-calendars-edit",
                                component: () => import("../views/app/company/company-calendar/CompanyCalendarForm")
                            },
                            {
                                path: ":id/view",
                                name: "company-calendars-view",
                                component: () => import("../views/app/company/company-calendar/CompanyCalendarForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "new-user-companies",
                        redirect: { name: "new-user-companies" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "new-user-companies",
                                component: () => import("../views/app/company/new-user-company/NewUserCompanyList")
                            },
                            {
                                path: "create",
                                name: "new-user-companies-create",
                                component: () => import("../views/app/company/new-user-company/NewUserCompanyForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "new-user-companies-view",
                                component: () => import("../views/app/company/new-user-company/NewUserCompanyForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "company-products",
                        redirect: { name: "company-products" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "company-products",
                                component: () => import("../views/app/company/company-product/CompanyProductList")
                            }
                        ]
                    },
                    {
                        path: "report",
                        redirect: { name: "company-report" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "company-report",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true }
                            },
                            {
                                path: "product",
                                redirect: { name: "company-report-product" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "company-report-product",
                                        component: () => import("../views/app/company/report/product/ProductList")
                                    }
                                ]
                            },
                            {
                                path: "lab-reject",
                                redirect: { name: "company-report-lab-reject" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "company-report-lab-reject",
                                        component: () => import("../views/app/company/report/lab-reject/LabRejectList")
                                    }
                                ]
                            },
                            {
                                path: "hc",
                                redirect: { name: "company-report-hc" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "company-report-hc",
                                        component: () => import("../views/app/company/report/hc/HcList")
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: "sampling",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "sampling",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "sampling-requests",
                        redirect: { name: "sampling-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-requests",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestList")
                            },
                            {
                                path: "create",
                                name: "sampling-requests-create",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-requests-edit",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestForm")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-requests-view",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-repeat-requests",
                        redirect: { name: "sampling-repeat-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-repeat-requests",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestList"),
                                props: { isRepeat: true }
                            },
                            {
                                path: "create",
                                name: "sampling-repeat-requests-create",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestForm"),
                                props: route => ({ isRepeat: true, ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-repeat-requests-edit",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestForm"),
                                props: { isRepeat: true }
                            },
                            {
                                path: ":id/view",
                                name: "sampling-repeat-requests-view",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestForm"),
                                props: { viewOnly: true, isRepeat: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-products",
                        redirect: { name: "sampling-products" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-products",
                                component: () => import("../views/app/sampling/sampling-product/SamplingProductList"),
                                props: {
                                    refSamplingRequestTypeKey: ["S", "L"]
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "sampling-report",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "sampling-report",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "sampling-report-requests",
                        redirect: { name: "sampling-report-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-report-requests",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestList")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-report-requests-view",
                                component: () => import("../views/app/sampling/sampling-request/SamplingRequestForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-product-statuss",
                        redirect: { name: "sampling-product-statuss" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-product-statuss",
                                component: () => import("../views/app/sampling/sampling-product/SamplingProductList"),
                                props: {
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    columnTemplate: "template4"
                                }
                            }
                        ]
                    },
                    {
                        path: "sampling-product-evaluates",
                        redirect: { name: "sampling-product-evaluates" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-product-evaluates",
                                component: () => import("../views/app/sampling/sampling-product/SamplingProductList"),
                                props: {
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    columnTemplate: "template5"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "certificate",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "certificate",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "certificate-requests",
                        redirect: { name: "certificate-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "certificate-requests",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestList"),
                                props: { routerPrefix: "certificate-requests" }
                            },
                            {
                                path: "create",
                                name: "certificate-requests-create",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: route => ({
                                    isTmp: route.params?.isTmp,
                                    ...JSON.parse(route.params?.props || null),
                                    routerPrefix: "certificate-requests"
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "certificate-requests-edit",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { routerPrefix: "certificate-requests" }
                            },
                            {
                                path: ":id/view",
                                name: "certificate-requests-view",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { viewOnly: true, routerPrefix: "certificate-requests" }
                            }
                        ]
                    },
                    {
                        path: "certificate-request-all-models",
                        redirect: { name: "certificate-request-all-models" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "certificate-request-all-models",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestList"),
                                props: { isAllModels: true, routerPrefix: "certificate-request-all-models" }
                            },
                            {
                                path: "create",
                                name: "certificate-request-all-models-create",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: route => ({
                                    isTmp: route.params?.isTmp,
                                    isAllModels: true,
                                    ...JSON.parse(route.params?.props || null),
                                    routerPrefix: "certificate-request-all-models"
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "certificate-request-all-models-edit",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { isAllModels: true, routerPrefix: "certificate-request-all-models" }
                            },
                            {
                                path: ":id/view",
                                name: "certificate-request-all-models-view",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: {
                                    isAllModels: true,
                                    viewOnly: true,
                                    routerPrefix: "certificate-request-all-models"
                                }
                            }
                        ]
                    },
                    {
                        path: "request-change-certificate",
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                component: () => import("../views/menu-list/MenuList")
                            },
                            {
                                path: "change-informations",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "change-informations",
                                        component: () => import("../views/app/certificate/certificate-request/CertificateRequestList"),
                                        props: route => ({
                                            isTmp: true,
                                            isRequestChangeInformation: true,
                                            columnTemplate: "template2",
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "change-informations"
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "change-informations-create",
                                        component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                        props: route => ({
                                            isTmp: true,
                                            isRequestChangeInformation: true,
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "change-informations"
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "change-informations-edit",
                                        component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                        props: route => ({
                                            isTmp: true,
                                            isRequestChangeInformation: true,
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "change-informations"
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "change-informations-view",
                                        component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                        props: route => ({
                                            viewOnly: true,
                                            isTmp: true,
                                            isRequestChangeInformation: true,
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "change-informations"
                                        })
                                    }
                                ]
                            },
                            {
                                path: "cancels",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "cancels",
                                        component: () => import("../views/app/certificate/certificate-request/CertificateRequestList"),
                                        props: route => ({
                                            isTmp: true,
                                            isRequestCancel: true,
                                            columnTemplate: "template2",
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "cancels"
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "cancels-create",
                                        component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                        props: route => ({
                                            isTmp: true,
                                            isRequestCancel: true,
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "cancels"
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "cancels-edit",
                                        component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                        props: route => ({
                                            isTmp: true,
                                            isRequestCancel: true,
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "cancels"
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "cancels-view",
                                        component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                        props: route => ({
                                            viewOnly: true,
                                            isTmp: true,
                                            isRequestCancel: true,
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "cancels"
                                        })
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "list-of-all-certificate-requests",
                        redirect: { name: "list-of-all-certificate-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "list-of-all-certificate-requests",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestList"),
                                props: {
                                    routerPrefix: "list-of-all-certificate-requests",
                                    showAllCertRequestAndNullAssignedTo: true,
                                    columnTemplate: "template3"
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "list-of-all-certificate-requests-edit",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { routerPrefix: "list-of-all-certificate-requests" }
                            },
                            {
                                path: ":id/view",
                                name: "list-of-all-certificate-requests-view",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { viewOnly: true, routerPrefix: "list-of-all-certificate-requests" }
                            }
                        ]
                    },
                    {
                        path: "responsible-certificate-request-lists",
                        redirect: { name: "responsible-certificate-request-lists" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "responsible-certificate-request-lists",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestList"),
                                props: {
                                    routerPrefix: "responsible-certificate-request-lists",
                                    columnTemplate: "template3",
                                    showMyAssigned: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "responsible-certificate-request-lists-edit",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { routerPrefix: "responsible-certificate-request-lists" }
                            },
                            {
                                path: ":id/view",
                                name: "responsible-certificate-request-lists-view",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { viewOnly: true, routerPrefix: "responsible-certificate-request-lists" }
                            }
                        ]
                    },
                    {
                        path: "certificate-request-completes",
                        redirect: { name: "certificate-request-completes" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "certificate-request-completes",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestList"),
                                props: {
                                    routerPrefix: "certificate-request-completes",
                                    columnTemplate: "template3",
                                    showCompleteCertRequest: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "certificate-request-completes-edit",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { routerPrefix: "certificate-request-completes" }
                            },
                            {
                                path: ":id/view",
                                name: "certificate-request-completes-view",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: { viewOnly: true, routerPrefix: "certificate-request-completes" }
                            }
                        ]
                    },
                    {
                        path: "certificate-amendment-request-lists",
                        redirect: { name: "certificate-amendment-request-lists" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "certificate-amendment-request-lists",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestList"),
                                props: route => ({
                                    isTmp: true,
                                    columnTemplate: "template4",
                                    ...JSON.parse(route.params?.props || null),
                                    routerPrefix: "certificate-amendment-request-lists"
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "certificate-amendment-request-lists-edit",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: route => ({
                                    isTmp: true,
                                    ...JSON.parse(route.params?.props || null),
                                    routerPrefix: "certificate-amendment-request-lists"
                                })
                            },
                            {
                                path: ":id/view",
                                name: "certificate-amendment-request-lists-view",
                                component: () => import("../views/app/certificate/certificate-request/CertificateRequestFrom"),
                                props: route => ({
                                    viewOnly: true,
                                    isTmp: true,
                                    ...JSON.parse(route.params?.props || null),
                                    routerPrefix: "certificate-amendment-request-lists"
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "approve-lists",
                redirect: { name: "approve-lists" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "approve-lists",
                        component: () => import("../views/app/approve-list/ApproveListList")
                    },
                    {
                        path: "create",
                        name: "approve-lists-create",
                        component: () => import("../views/app/approve-list/ApproveListForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/edit",
                        name: "approve-lists-edit",
                        component: () => import("../views/app/approve-list/ApproveListForm")
                    },
                    {
                        path: ":id/view",
                        name: "approve-lists-view",
                        component: () => import("../views/app/approve-list/ApproveListForm"),
                        props: { viewOnly: true }
                    }
                ]
            },
            {
                path: "master-mgt",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "master-mgt",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "company-types",
                        redirect: { name: "company-types" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "company-types",
                                component: () => import("../views/app/master-mgt/company-type/CompanyTypeList")
                            },
                            {
                                path: "create",
                                name: "company-types-create",
                                component: () => import("../views/app/master-mgt/company-type/CompanyTypeForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "company-types-edit",
                                component: () => import("../views/app/master-mgt/company-type/CompanyTypeForm")
                            },
                            {
                                path: ":id/view",
                                name: "company-types-view",
                                component: () => import("../views/app/master-mgt/company-type/CompanyTypeForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-frequency-types",
                        redirect: { name: "sampling-frequency-types" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-frequency-types",
                                component: () => import("../views/app/master-mgt/sampling-frequency-type/SamplingFrequencyTypeList")
                            },
                            {
                                path: "create",
                                name: "sampling-frequency-types-create",
                                component: () => import("../views/app/master-mgt/sampling-frequency-type/SamplingFrequencyTypeForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-frequency-types-edit",
                                component: () => import("../views/app/master-mgt/sampling-frequency-type/SamplingFrequencyTypeForm")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-frequency-types-view",
                                component: () => import("../views/app/master-mgt/sampling-frequency-type/SamplingFrequencyTypeForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "products",
                        redirect: { name: "products" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "products",
                                component: () => import("../views/app/master-mgt/product/ProductList")
                            },
                            {
                                path: "create",
                                name: "products-create",
                                component: () => import("../views/app/master-mgt/product/ProductForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "products-edit",
                                component: () => import("../views/app/master-mgt/product/ProductForm")
                            },
                            {
                                path: ":id/view",
                                name: "products-view",
                                component: () => import("../views/app/master-mgt/product/ProductForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-monitor-products",
                        redirect: { name: "sampling-monitor-products" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-monitor-products",
                                component: () => import("../views/app/master-mgt/sampling-monitor-product/SamplingMonitorProductList")
                            },
                            {
                                path: "create",
                                name: "sampling-monitor-products-create",
                                component: () => import("../views/app/master-mgt/sampling-monitor-product/SamplingMonitorProductForm")
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-monitor-products-edit",
                                component: () => import("../views/app/master-mgt/sampling-monitor-product/SamplingMonitorProductForm")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-monitor-products-view",
                                component: () => import("../views/app/master-mgt/sampling-monitor-product/SamplingMonitorProductForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "countries",
                        redirect: { name: "countries" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "countries",
                                component: () => import("../views/app/master-mgt/country/CountryList")
                            },
                            {
                                path: "create",
                                name: "countries-create",
                                component: () => import("../views/app/master-mgt/country/CountryForm"),
                                props: route => ({ isCreateForm: true, visibleChildren: true, ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "countries-edit",
                                component: () => import("../views/app/master-mgt/country/CountryForm"),
                                props: { isEditForm: true, visibleChildren: true }
                            },
                            {
                                path: ":id/view",
                                name: "countries-view",
                                component: () => import("../views/app/master-mgt/country/CountryForm"),
                                props: { visibleChildren: true, viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "country-requests",
                        redirect: { name: "country-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "country-requests",
                                component: () => import("../views/app/master-mgt/country-request/CountryRequestList")
                            },
                            {
                                path: "create",
                                name: "country-requests-create",
                                component: () => import("../views/app/master-mgt/country-request/CountryRequestForm"),
                                props: route => ({ isCreateForm: true, visibleChildren: true, ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "country-requests-edit",
                                component: () => import("../views/app/master-mgt/country-request/CountryRequestForm"),
                                props: { isEditForm: true, visibleChildren: true }
                            },
                            {
                                path: ":id/view",
                                name: "country-requests-view",
                                component: () => import("../views/app/master-mgt/country-request/CountryRequestForm"),
                                props: { visibleChildren: true, viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "gmp-lvs",
                        redirect: { name: "gmp-lvs" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "gmp-lvs",
                                component: () => import("../views/app/master-mgt/gmp-lv/GmpLvList")
                            },
                            {
                                path: "create",
                                name: "gmp-lvs-create",
                                component: () => import("../views/app/master-mgt/gmp-lv/GmpLvForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "gmp-lvs-edit",
                                component: () => import("../views/app/master-mgt/gmp-lv/GmpLvForm")
                            },
                            {
                                path: ":id/view",
                                name: "gmp-lvs-view",
                                component: () => import("../views/app/master-mgt/gmp-lv/GmpLvForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "department-responsibles",
                        redirect: { name: "department-responsibles" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "department-responsibles",
                                component: () => import("../views/app/master-mgt/department-responsible/DepartmentResponsibleList")
                            },
                            {
                                path: "create",
                                name: "department-responsibles-create",
                                component: () => import("../views/app/master-mgt/department-responsible/DepartmentResponsibleForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "department-responsibles-edit",
                                component: () => import("../views/app/master-mgt/department-responsible/DepartmentResponsibleForm")
                            },
                            {
                                path: ":id/view",
                                name: "department-responsibles-view",
                                component: () => import("../views/app/master-mgt/department-responsible/DepartmentResponsibleForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "product-types",
                        redirect: { name: "product-types" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "product-types",
                                component: () => import("../views/app/master-mgt/product-type/ProductTypeList")
                            },
                            {
                                path: "create",
                                name: "product-types-create",
                                component: () => import("../views/app/master-mgt/product-type/ProductTypeForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "product-types-edit",
                                component: () => import("../views/app/master-mgt/product-type/ProductTypeForm")
                            },
                            {
                                path: ":id/view",
                                name: "product-types-view",
                                component: () => import("../views/app/master-mgt/product-type/ProductTypeForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "product-consumptions",
                        redirect: { name: "product-consumptions" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "product-consumptions",
                                component: () => import("../views/app/master-mgt/product-consumption/ProductConsumptionList")
                            },
                            {
                                path: "create",
                                name: "product-consumptions-create",
                                component: () => import("../views/app/master-mgt/product-consumption/ProductConsumptionForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "product-consumptions-edit",
                                component: () => import("../views/app/master-mgt/product-consumption/ProductConsumptionForm")
                            },
                            {
                                path: ":id/view",
                                name: "product-consumptions-view",
                                component: () => import("../views/app/master-mgt/product-consumption/ProductConsumptionForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "aquatic-sources",
                        redirect: { name: "aquatic-sources" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "aquatic-sources",
                                component: () => import("../views/app/master-mgt/aquatic-source/AquaticSourceList")
                            },
                            {
                                path: "create",
                                name: "aquatic-sources-create",
                                component: () => import("../views/app/master-mgt/aquatic-source/AquaticSourceForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "aquatic-sources-edit",
                                component: () => import("../views/app/master-mgt/aquatic-source/AquaticSourceForm")
                            },
                            {
                                path: ":id/view",
                                name: "aquatic-sources-view",
                                component: () => import("../views/app/master-mgt/aquatic-source/AquaticSourceForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "aquatic-types",
                        redirect: { name: "aquatic-types" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "aquatic-types",
                                component: () => import("../views/app/master-mgt/aquatic-type/AquaticTypeList")
                            },
                            {
                                path: "create",
                                name: "aquatic-types-create",
                                component: () => import("../views/app/master-mgt/aquatic-type/AquaticTypeForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "aquatic-types-edit",
                                component: () => import("../views/app/master-mgt/aquatic-type/AquaticTypeForm")
                            },
                            {
                                path: ":id/view",
                                name: "aquatic-types-view",
                                component: () => import("../views/app/master-mgt/aquatic-type/AquaticTypeForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "aquatic-species",
                        redirect: { name: "aquatic-species" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "aquatic-species",
                                component: () => import("../views/app/master-mgt/aquatic-species/AquaticSpeciesList")
                            },
                            {
                                path: "create",
                                name: "aquatic-species-create",
                                component: () => import("../views/app/master-mgt/aquatic-species/AquaticSpeciesForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "aquatic-species-edit",
                                component: () => import("../views/app/master-mgt/aquatic-species/AquaticSpeciesForm")
                            },
                            {
                                path: ":id/view",
                                name: "aquatic-species-view",
                                component: () => import("../views/app/master-mgt/aquatic-species/AquaticSpeciesForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "product-methods",
                        redirect: { name: "product-methods" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "product-methods",
                                component: () => import("../views/app/master-mgt/product-method/ProductMethodList")
                            },
                            {
                                path: "create",
                                name: "product-methods-create",
                                component: () => import("../views/app/master-mgt/product-method/ProductMethodForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "product-methods-edit",
                                component: () => import("../views/app/master-mgt/product-method/ProductMethodForm")
                            },
                            {
                                path: ":id/view",
                                name: "product-methods-view",
                                component: () => import("../views/app/master-mgt/product-method/ProductMethodForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "product-features",
                        redirect: { name: "product-features" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "product-features",
                                component: () => import("../views/app/master-mgt/product-feature/ProductFeatureList")
                            },
                            {
                                path: "create",
                                name: "product-features-create",
                                component: () => import("../views/app/master-mgt/product-feature/ProductFeatureForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "product-features-edit",
                                component: () => import("../views/app/master-mgt/product-feature/ProductFeatureForm")
                            },
                            {
                                path: ":id/view",
                                name: "product-features-view",
                                component: () => import("../views/app/master-mgt/product-feature/ProductFeatureForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "lab-companies",
                        redirect: { name: "lab-companies" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-companies",
                                component: () => import("../views/app/master-mgt/lab-company/LabCompanyList")
                            },
                            {
                                path: "create",
                                name: "lab-companies-create",
                                component: () => import("../views/app/master-mgt/lab-company/LabCompanyForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "lab-companies-edit",
                                component: () => import("../views/app/master-mgt/lab-company/LabCompanyForm")
                            },
                            {
                                path: ":id/view",
                                name: "lab-companies-view",
                                component: () => import("../views/app/master-mgt/lab-company/LabCompanyForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "lab",
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                component: () => import("../views/menu-list/MenuList")
                            },
                            {
                                path: "topic-units",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "topic-units",
                                        component: () => import("../views/app/master-mgt/lab/topic-unit/TopicUnitList")
                                    },
                                    {
                                        path: "create",
                                        name: "topic-units-create",
                                        component: () => import("../views/app/master-mgt/lab/topic-unit/TopicUnitForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "topic-units-edit",
                                        component: () => import("../views/app/master-mgt/lab/topic-unit/TopicUnitForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "topic-units-view",
                                        component: () => import("../views/app/master-mgt/lab/topic-unit/TopicUnitForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            },
                            {
                                path: "topics",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "topics",
                                        component: () => import("../views/app/master-mgt/lab/topic/TopicList")
                                    },
                                    {
                                        path: "create",
                                        name: "topics-create",
                                        component: () => import("../views/app/master-mgt/lab/topic/TopicForm"),
                                        props: route => ({ visibleChildren: true, ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "topics-edit",
                                        component: () => import("../views/app/master-mgt/lab/topic/TopicForm"),
                                        props: { visibleChildren: true }
                                    },
                                    {
                                        path: ":id/view",
                                        name: "topics-view",
                                        component: () => import("../views/app/master-mgt/lab/topic/TopicForm"),
                                        props: { visibleChildren: true, viewOnly: true }
                                    }
                                ]
                            },
                            {
                                path: "topic-methods",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "topic-methods",
                                        component: () => import("../views/app/master-mgt/lab/topic-method/TopicMethodList")
                                    },
                                    {
                                        path: "create",
                                        name: "topic-methods-create",
                                        component: () => import("../views/app/master-mgt/lab/topic-method/TopicMethodForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "topic-methods-edit",
                                        component: () => import("../views/app/master-mgt/lab/topic-method/TopicMethodForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "topic-methods-view",
                                        component: () => import("../views/app/master-mgt/lab/topic-method/TopicMethodForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            },
                            {
                                path: "lab-physic-monitor-product-topic-methods",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "lab-physic-monitor-product-topic-methods",
                                        component: () =>
                                            import(
                                                "../views/app/master-mgt/lab/lab-physic-monitor-product-topic-method/LabPhysicMonitorProductTopicMethodList"
                                            )
                                    },
                                    {
                                        path: "create",
                                        name: "lab-physic-monitor-product-topic-methods-create",
                                        component: () =>
                                            import(
                                                "../views/app/master-mgt/lab/lab-physic-monitor-product-topic-method/LabPhysicMonitorProductTopicMethodForm"
                                            ),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "lab-physic-monitor-product-topic-methods-edit",
                                        component: () =>
                                            import(
                                                "../views/app/master-mgt/lab/lab-physic-monitor-product-topic-method/LabPhysicMonitorProductTopicMethodForm"
                                            )
                                    },
                                    {
                                        path: ":id/view",
                                        name: "lab-physic-monitor-product-topic-methods-view",
                                        component: () =>
                                            import(
                                                "../views/app/master-mgt/lab/lab-physic-monitor-product-topic-method/LabPhysicMonitorProductTopicMethodForm"
                                            ),
                                        props: { viewOnly: true }
                                    }
                                ]
                            },
                            {
                                path: "lab-export",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        component: () => import("../views/menu-list/MenuList")
                                    },
                                    {
                                        path: "country-standard-groups",
                                        component: RouteView,
                                        children: [
                                            {
                                                path: "",
                                                name: "country-standard-groups",
                                                component: () => import("../views/app/master-mgt/lab/country-standard-group/CountryStandardGroupList")
                                            },
                                            {
                                                path: "create",
                                                name: "country-standard-groups-create",
                                                component: () =>
                                                    import("../views/app/master-mgt/lab/country-standard-group/CountryStandardGroupForm"),
                                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                                            },
                                            {
                                                path: ":id/edit",
                                                name: "country-standard-groups-edit",
                                                component: () => import("../views/app/master-mgt/lab/country-standard-group/CountryStandardGroupForm")
                                            },
                                            {
                                                path: ":id/view",
                                                name: "country-standard-groups-view",
                                                component: () =>
                                                    import("../views/app/master-mgt/lab/country-standard-group/CountryStandardGroupForm"),
                                                props: { viewOnly: true }
                                            }
                                        ]
                                    },
                                    {
                                        path: "country-standard-groups-mapper",
                                        component: RouteView,
                                        children: [
                                            {
                                                path: "",
                                                name: "country-standard-groups-mapper",
                                                component: () =>
                                                    import("../views/app/master-mgt/lab/country-standard-group-mapper/CountryStandardGroupMapperList")
                                            }
                                        ]
                                    },
                                    {
                                        path: "country-standard-group-topics",
                                        component: RouteView,
                                        children: [
                                            {
                                                path: "",
                                                name: "country-standard-group-topics",
                                                component: () =>
                                                    import("../views/app/master-mgt/lab/country-standard-group-topic/CountryStandardGroupTopicList")
                                            }
                                        ]
                                    },
                                    {
                                        path: "product-group",
                                        component: RouteView,
                                        children: [
                                            {
                                                path: "",
                                                name: "product-group",
                                                component: () => import("../views/app/master-mgt/lab/product-group/ListProductGroup")
                                            },
                                            {
                                                path: "create",
                                                name: "product-group-create",
                                                component: () => import("../views/app/master-mgt/lab/product-group/ProductGroupForm"),
                                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                                            },
                                            {
                                                path: ":id/edit",
                                                name: "product-group-edit",
                                                component: () => import("../views/app/master-mgt/lab/product-group/ProductGroupForm")
                                            },
                                            {
                                                path: ":id/view",
                                                name: "product-group-view",
                                                component: () => import("../views/app/master-mgt/lab/product-group/ProductGroupForm"),
                                                props: { viewOnly: true }
                                            }
                                        ]
                                    },
                                    {
                                        path: "product-grouping",
                                        component: RouteView,
                                        children: [
                                            {
                                                path: "",
                                                name: "product-grouping",
                                                component: () => import("../views/app/master-mgt/lab/product-grouping/ListProductGrouping"),
                                                props: { labType: "labMicro" }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: "lab-monitor",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        component: () => import("../views/menu-list/MenuList")
                                    },
                                    {
                                        path: "lab-monitor-product-groups",
                                        component: RouteView,
                                        children: [
                                            {
                                                path: "",
                                                name: "lab-monitor-product-groups",
                                                component: () =>
                                                    import("../views/app/master-mgt/lab/lab-monitor-product-group/LabMonitorProductGroupList")
                                            },
                                            {
                                                path: "create",
                                                name: "lab-monitor-product-groups-create",
                                                component: () =>
                                                    import("../views/app/master-mgt/lab/lab-monitor-product-group/LabMonitorProductGroupForm")
                                            },
                                            {
                                                path: ":id/edit",
                                                name: "lab-monitor-product-groups-edit",
                                                component: () =>
                                                    import("../views/app/master-mgt/lab/lab-monitor-product-group/LabMonitorProductGroupForm")
                                            },
                                            {
                                                path: ":id/view",
                                                name: "lab-monitor-product-groups-view",
                                                component: () =>
                                                    import("../views/app/master-mgt/lab/lab-monitor-product-group/LabMonitorProductGroupForm"),
                                                props: { viewOnly: true }
                                            }
                                        ]
                                    },
                                    {
                                        path: "lab-monitor-product-group-rels",
                                        component: RouteView,
                                        children: [
                                            {
                                                path: "",
                                                name: "lab-monitor-product-group-rels",
                                                component: () =>
                                                    import(
                                                        "../views/app/master-mgt/lab/lab-monitor-product-group-rel/ListLabMonitorProductGroupRelForm"
                                                    )
                                            },
                                            {
                                                path: "create",
                                                name: "lab-monitor-product-group-rels-create",
                                                component: () =>
                                                    import(
                                                        "../views/app/master-mgt/lab/lab-monitor-product-group-rel/ListLabMonitorProductGroupRelForm"
                                                    )
                                            },
                                            {
                                                path: ":id/edit",
                                                name: "lab-monitor-product-group-rels-edit",
                                                component: () =>
                                                    import(
                                                        "../views/app/master-mgt/lab/lab-monitor-product-group-rel/ListLabMonitorProductGroupRelForm"
                                                    )
                                            },
                                            {
                                                path: ":id/view",
                                                name: "lab-monitor-product-group-rels-view",
                                                component: () =>
                                                    import(
                                                        "../views/app/master-mgt/lab/lab-monitor-product-group-rel/ListLabMonitorProductGroupRelForm"
                                                    ),
                                                props: { viewOnly: true }
                                            }
                                        ]
                                    },
                                    {
                                        path: "lab-monitor-product-group-topics",
                                        component: RouteView,
                                        children: [
                                            {
                                                path: "",
                                                name: "lab-monitor-product-group-topics",
                                                component: () =>
                                                    import(
                                                        "../views/app/master-mgt/lab/lab-monitor-product-group-topic/LabMonitorProductGroupTopicList"
                                                    )
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: "sampling-monitor-type-lab-topics",
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "sampling-monitor-type-lab-topics",
                                        component: () =>
                                            import("../views/app/master-mgt/lab/sampling-monitor-type-lab-topic/SamplingMonitorTypeLabTopicList")
                                    },
                                    {
                                        path: "create",
                                        name: "sampling-monitor-type-lab-topics-create",
                                        component: () =>
                                            import("../views/app/master-mgt/lab/sampling-monitor-type-lab-topic/SamplingMonitorTypeLabTopicForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "sampling-monitor-type-lab-topics-edit",
                                        component: () =>
                                            import("../views/app/master-mgt/lab/sampling-monitor-type-lab-topic/SamplingMonitorTypeLabTopicForm")
                                    },
                                    {
                                        path: ":id/view",
                                        name: "sampling-monitor-type-lab-topics-view",
                                        component: () =>
                                            import("../views/app/master-mgt/lab/sampling-monitor-type-lab-topic/SamplingMonitorTypeLabTopicForm")
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "sampling-monitor-types",
                        redirect: { name: "sampling-monitor-types" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-monitor-types",
                                component: () => import("../views/app/master-mgt/sampling-monitor-type/SamplingMonitorTypeList")
                            },
                            {
                                path: "create",
                                name: "sampling-monitor-types-create",
                                component: () => import("../views/app/master-mgt/sampling-monitor-type/SamplingMonitorTypeForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-monitor-types-edit",
                                component: () => import("../views/app/master-mgt/sampling-monitor-type/SamplingMonitorTypeForm")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-monitor-types-view",
                                component: () => import("../views/app/master-mgt/sampling-monitor-type/SamplingMonitorTypeForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-monitor-species",
                        redirect: { name: "sampling-monitor-species" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-monitor-species",
                                component: () => import("../views/app/master-mgt/sampling-monitor-species/SamplingMonitorSpeciesList")
                            },
                            {
                                path: "create",
                                name: "sampling-monitor-species-create",
                                component: () => import("../views/app/master-mgt/sampling-monitor-species/SamplingMonitorSpeciesForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-monitor-species-edit",
                                component: () => import("../views/app/master-mgt/sampling-monitor-species/SamplingMonitorSpeciesForm")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-monitor-species-view",
                                component: () => import("../views/app/master-mgt/sampling-monitor-species/SamplingMonitorSpeciesForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-monitor-source-types",
                        redirect: { name: "sampling-monitor-species" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-monitor-source-types",
                                component: () => import("../views/app/master-mgt/sampling-monitor-source-type/SamplingMonitorSourceTypeList")
                            },
                            {
                                path: "create",
                                name: "sampling-monitor-source-types-create",
                                component: () => import("../views/app/master-mgt/sampling-monitor-source-type/SamplingMonitorSourceTypeForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-monitor-source-types-edit",
                                component: () => import("../views/app/master-mgt/sampling-monitor-source-type/SamplingMonitorSourceTypeForm")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-monitor-source-types-view",
                                component: () => import("../views/app/master-mgt/sampling-monitor-source-type/SamplingMonitorSourceTypeForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "lab-exts",
                        redirect: { name: "lab-exts" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-exts",
                                component: () => import("../views/app/master-mgt/lab-ext/LabExtList")
                            },
                            {
                                path: "create",
                                name: "lab-exts-create",
                                component: () => import("../views/app/master-mgt/lab-ext/LabExtForm"),
                                props: route => ({ isCreateForm: true, ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "lab-exts-edit",
                                component: () => import("../views/app/master-mgt/lab-ext/LabExtForm")
                            },
                            {
                                path: ":id/view",
                                name: "lab-exts-view",
                                component: () => import("../views/app/master-mgt/lab-ext/LabExtForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-monitor-department-others",
                        redirect: { name: "sampling-monitor-species" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-monitor-department-others",
                                component: () =>
                                    import("../views/app/master-mgt/sampling-monitor-department-other/SamplingMonitorDepartmentOtherList")
                            },
                            {
                                path: "create",
                                name: "sampling-monitor-department-others-create",
                                component: () =>
                                    import("../views/app/master-mgt/sampling-monitor-department-other/SamplingMonitorDepartmentOtherForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-monitor-department-others-edit",
                                component: () =>
                                    import("../views/app/master-mgt/sampling-monitor-department-other/SamplingMonitorDepartmentOtherForm")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-monitor-department-others-view",
                                component: () =>
                                    import("../views/app/master-mgt/sampling-monitor-department-other/SamplingMonitorDepartmentOtherForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "marquee-news",
                        redirect: { name: "marquee-news" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "marquee-news",
                                component: () => import("../views/app/master-mgt/marquee-news/MarqueenNewsForm")
                            }
                        ]
                    }
                ]
            },
            {
                path: "lab-physic",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "lab-physic",
                        component: () => import("../views/menu-list/MenuList")
                    },
                    {
                        path: "analysis-exports",
                        redirect: { name: "lab-physic-sampling-product-analysis-exports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-physic-sampling-product-analysis-exports",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-physic-sampling-product-analysis-exports",
                                    refLabTypeKey: "labPhysic",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-physic-sampling-product-analysis-exports-view",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-physic-sampling-product-analysis-exports",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-physic-sampling-product-analysis-exports-edit",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    routerPrefix: "lab-physic-sampling-product-analysis-exports",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-cross-centers",
                        redirect: { name: "lab-physic-sampling-product-analysis-cross-centers" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-physic-sampling-product-analysis-cross-centers",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-physic-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labPhysic",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-physic-sampling-product-analysis-cross-centers-view",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-physic-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labPhysic",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"]
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-physic-sampling-product-analysis-cross-centers-edit",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    routerPrefix: "lab-physic-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labPhysic",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"]
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-monitors",
                        redirect: { name: "lab-physic-sampling-product-analysis-monitors" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-physic-sampling-product-analysis-monitors",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-physic-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labPhysic",
                                    refSamplingRequestTypeKey: ["M"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-physic-sampling-product-analysis-monitors-view",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-physic-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labPhysic",
                                    refSamplingRequestTypeKey: ["M"]
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-physic-sampling-product-analysis-monitors-edit",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    routerPrefix: "lab-physic-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labPhysic",
                                    refSamplingRequestTypeKey: ["M"]
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-all",
                        redirect: { name: "lab-physic-sampling-product-analysis-all" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-physic-sampling-product-analysis-all",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-physic-sampling-product-analysis-all",
                                    refLabTypeKey: "labPhysic",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isSetDefaultSearchStatusByRoleMenu: true,
                                    isCanEditAllState: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-physic-sampling-product-analysis-all-view",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-physic-sampling-product-analysis-all",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isSetDefaultSearchStatusByRoleMenu: true,
                                    isCanEditAllState: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-physic-sampling-product-analysis-all-edit",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    routerPrefix: "lab-physic-sampling-product-analysis-all",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isSetDefaultSearchStatusByRoleMenu: true,
                                    isCanEditAllState: true
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "lab-micro",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "lab-micro",
                        component: () => import("../views/menu-list/MenuList")
                    },
                    {
                        path: "analysis-exports",
                        redirect: { name: "lab-micro-sampling-product-analysis-exports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-micro-sampling-product-analysis-exports",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-micro-sampling-product-analysis-exports",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-micro-sampling-product-analysis-exports-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-micro-sampling-product-analysis-exports",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-micro-sampling-product-analysis-exports-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-micro-sampling-product-analysis-exports",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-cross-centers",
                        redirect: { name: "lab-micro-sampling-product-analysis-cross-centers" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-micro-sampling-product-analysis-cross-centers",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-micro-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labMicro",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-micro-sampling-product-analysis-cross-centers-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-micro-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labMicro",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"]
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-micro-sampling-product-analysis-cross-centers-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-micro-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labMicro",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"]
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-monitors",
                        redirect: { name: "lab-micro-sampling-product-analysis-monitors" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-micro-sampling-product-analysis-monitors",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-micro-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["M"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-micro-sampling-product-analysis-monitors-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-micro-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["M"]
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-micro-sampling-product-analysis-monitors-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-micro-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["M"]
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-all",
                        redirect: { name: "lab-micro-sampling-product-analysis-all" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-micro-sampling-product-analysis-all",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-micro-sampling-product-analysis-all",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isCanEditAllState: true,
                                    defaultSearchStatusKey: "Send Result",
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-micro-sampling-product-analysis-all-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-micro-sampling-product-analysis-all",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isCanEditAllState: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-micro-sampling-product-analysis-all-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-micro-sampling-product-analysis-all",
                                    refLabTypeKey: "labMicro",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isCanEditAllState: true
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "lab-micro-report",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "lab-micro-report",
                        component: () => import("../views/menu-list/MenuList")
                    },
                    {
                        path: "work-time-reports",
                        redirect: { name: "lab-micro-report-working-time-reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-micro-report-working-time-reports",
                                component: () => import("../views/app/lab/report/WorkTimeReport"),
                                props: {
                                    refLabTypeKey: "labMicro"
                                }
                            }
                        ]
                    },
                    {
                        path: "topic-reject-reports",
                        redirect: { name: "lab-micro-report-topic-reject-reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-micro-report-topic-reject-reports",
                                component: () => import("../views/app/lab/report/TopicRejectReport"),
                                props: {
                                    refLabTypeKey: "labMicro"
                                }
                            }
                        ]
                    },
                    {
                        path: "export-product-topic-reports",
                        redirect: { name: "lab-micro-report-product-topic-reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-micro-report-product-topic-reports",
                                component: () => import("../views/app/lab/report/ExportProductTopicReport"),
                                props: {
                                    refLabTypeKey: "labMicro"
                                }
                            }
                        ]
                    },
                    {
                        path: "monitor-product-topic-reports",
                        redirect: { name: "lab-micro-report-monitor-product-topic-reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-micro-report-monitor-product-topic-reports",
                                component: () => import("../views/app/lab/report/MonitorProductTopicReport"),
                                props: {
                                    refLabTypeKey: "labMicro"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "lab-chemi",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "lab-chemi",
                        component: () => import("../views/menu-list/MenuList")
                    },
                    {
                        path: "analysis-exports",
                        redirect: { name: "lab-chemi-sampling-product-analysis-exports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-chemi-sampling-product-analysis-exports",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-chemi-sampling-product-analysis-exports",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-chemi-sampling-product-analysis-exports-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-chemi-sampling-product-analysis-exports",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["S", "L"]
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-chemi-sampling-product-analysis-exports-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-chemi-sampling-product-analysis-exports",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["S", "L"]
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-cross-centers",
                        redirect: { name: "lab-chemi-sampling-product-analysis-cross-centers" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-chemi-sampling-product-analysis-cross-centers",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-chemi-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labChemi",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-chemi-sampling-product-analysis-cross-centers-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-chemi-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labChemi",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-chemi-sampling-product-analysis-cross-centers-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-chemi-sampling-product-analysis-cross-centers",
                                    refLabTypeKey: "labChemi",
                                    refExtCenterTypeKey: "Cross Center",
                                    refSamplingRequestTypeKey: ["S", "L", "M"]
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-monitors",
                        redirect: { name: "lab-chemi-sampling-product-analysis-monitors" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-chemi-sampling-product-analysis-monitors",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-chemi-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["M"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-chemi-sampling-product-analysis-monitors-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-chemi-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["M"]
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-chemi-sampling-product-analysis-monitors-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-chemi-sampling-product-analysis-monitors",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["M"]
                                }
                            }
                        ]
                    },
                    {
                        path: "analysis-all",
                        redirect: { name: "lab-chemi-sampling-product-analysis-all" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-chemi-sampling-product-analysis-all",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-chemi-sampling-product-analysis-all",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isSetDefaultSearchStatusByRoleMenu: true,
                                    isCanEditAllState: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-chemi-sampling-product-analysis-all-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-chemi-sampling-product-analysis-all",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isCanEditAllState: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-chemi-sampling-product-analysis-all-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-chemi-sampling-product-analysis-all",
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["S", "L", "M"],
                                    isCanEditAllState: true
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "lab-chemi-report",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "lab-chemi-report",
                        component: () => import("../views/menu-list/MenuList")
                    },
                    {
                        path: "work-time-reports",
                        redirect: { name: "lab-chemi-report-working-time-reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-chemi-report-working-time-reports",
                                component: () => import("../views/app/lab/report/WorkTimeReport"),
                                props: {
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            }
                        ]
                    },
                    {
                        path: "topic-reject-reports",
                        redirect: { name: "lab-chemi-report-topic-reject-reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-chemi-report-topic-reject-reports",
                                component: () => import("../views/app/lab/report/TopicRejectReport"),
                                props: {
                                    refLabTypeKey: "labChemi",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            }
                        ]
                    },
                    {
                        path: "export-product-topic-reports",
                        redirect: { name: "lab-chemi-report-product-topic-reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-chemi-report-product-topic-reports",
                                component: () => import("../views/app/lab/report/ExportProductTopicReport"),
                                props: {
                                    refLabTypeKey: "labChemi"
                                }
                            }
                        ]
                    },
                    {
                        path: "monitor-product-topic-reports",
                        redirect: { name: "lab-chemi-report-monitor-product-topic-reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-chemi-report-monitor-product-topic-reports",
                                component: () => import("../views/app/lab/report/MonitorProductTopicReport"),
                                props: {
                                    refLabTypeKey: "labChemi"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "lab-physic-report",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "lab-physic-report",
                        component: () => import("../views/menu-list/MenuList")
                    },
                    {
                        path: "results",
                        redirect: { name: "lab-physic-report-results" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-physic-report-results",
                                component: () => import("../views/app/lab/report/physic/result/Result"),
                                props: {
                                    refLabTypeKey: "labPhysic"
                                }
                            }
                        ]
                    },
                    {
                        path: "result-by-departments",
                        redirect: { name: "lab-physic-report-result-by-departments" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-physic-report-result-by-departments",
                                component: () => import("../views/app/lab/report/physic/result/ResultByDepartmentReport"),
                                props: {
                                    refLabTypeKey: "labPhysic",
                                    refSamplingRequestTypeKey: ["S", "L", "M"]
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "lab-ext",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "lab-ext",
                        component: () => import("../views/menu-list/MenuList")
                    },
                    {
                        path: "sampling-product-analysiss",
                        redirect: { name: "lab-ext-sampling-product-analysiss" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-ext-sampling-product-analysiss",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-ext-sampling-product-analysiss",
                                    refLabTypeKey: null,
                                    showLabTypeKey: true,
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-ext-sampling-product-analysiss-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-ext-sampling-product-analysiss",
                                    refLabTypeKey: null,
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    visibleAttachment: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-ext-sampling-product-analysiss-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-ext-sampling-product-analysiss",
                                    refLabTypeKey: null,
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    visibleAttachment: true
                                }
                            }
                        ]
                    },
                    {
                        path: "lab-micro-sampling-product-analysiss",
                        redirect: { name: "lab-ext-lab-micro-sampling-product-analysiss" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-ext-lab-micro-sampling-product-analysiss",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-ext-lab-micro-sampling-product-analysiss",
                                    refLabTypeKey: "labMicro",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-ext-lab-micro-sampling-product-analysiss-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-ext-lab-micro-sampling-product-analysiss",
                                    refLabTypeKey: "labMicro",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    visibleAttachment: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-ext-lab-micro-sampling-product-analysiss-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-ext-lab-micro-sampling-product-analysiss",
                                    refLabTypeKey: "labMicro",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    visibleAttachment: true
                                }
                            }
                        ]
                    },
                    {
                        path: "lab-chemi-sampling-product-analysiss",
                        redirect: { name: "lab-ext-lab-chemi-sampling-product-analysiss" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-ext-lab-chemi-sampling-product-analysiss",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-ext-lab-chemi-sampling-product-analysiss",
                                    refLabTypeKey: "labChemi",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-ext-lab-chemi-sampling-product-analysiss-view",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-ext-lab-chemi-sampling-product-analysiss",
                                    refLabTypeKey: "labChemi",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    visibleAttachment: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-ext-lab-chemi-sampling-product-analysiss-edit",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisForm"),
                                props: {
                                    routerPrefix: "lab-ext-lab-chemi-sampling-product-analysiss",
                                    refLabTypeKey: "labChemi",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    visibleAttachment: true
                                }
                            }
                        ]
                    },
                    {
                        path: "lab-physic-sampling-product-analysiss",
                        redirect: { name: "lab-ext-lab-physic-sampling-product-analysiss" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lab-ext-lab-physic-sampling-product-analysiss",
                                component: () => import("../views/app/lab/sampling-product-analysis/AnalysisList"),
                                props: {
                                    routerPrefix: "lab-ext-lab-physic-sampling-product-analysiss",
                                    refLabTypeKey: "labPhysic",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    isSetDefaultSearchStatusByRoleMenu: true
                                }
                            },
                            {
                                path: ":id/view",
                                name: "lab-ext-lab-physic-sampling-product-analysiss-view",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    viewOnly: true,
                                    routerPrefix: "lab-ext-lab-physic-sampling-product-analysiss",
                                    refLabTypeKey: "labPhysic",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    visibleAttachment: true
                                }
                            },
                            {
                                path: ":id/edit",
                                name: "lab-ext-lab-physic-sampling-product-analysiss-edit",
                                component: () => import("../views/app/lab/physical/physical-analysis/PhysicalAnalysisForm"),
                                props: {
                                    routerPrefix: "lab-ext-lab-physic-sampling-product-analysiss",
                                    refLabTypeKey: "labPhysic",
                                    refExtCenterTypeKey: "Lab Ext",
                                    refSamplingRequestTypeKey: ["S", "L"],
                                    visibleAttachment: true
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "sampling-monitor",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "sampling-monitor",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "sampling-monitors",
                        redirect: { name: "sampling-monitors" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-monitors",
                                component: () => import("../views/app/sampling-monitor/sampling-monitor/SamplingMonitorList")
                            },
                            {
                                path: "create",
                                name: "sampling-monitors-create",
                                component: () => import("../views/app/sampling-monitor/sampling-monitor/SamplingMonitorForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "sampling-monitors-edit",
                                component: () => import("../views/app/sampling-monitor/sampling-monitor/SamplingMonitorForm")
                            },
                            {
                                path: ":id/view",
                                name: "sampling-monitors-view",
                                component: () => import("../views/app/sampling-monitor/sampling-monitor/SamplingMonitorForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "sampling-products",
                        redirect: { name: "sampling-monitor-sampling-products" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sampling-monitor-sampling-products",
                                component: () => import("../views/app/sampling/sampling-product/SamplingProductList"),
                                props: {
                                    refSamplingRequestTypeKey: ["M"],
                                    columnTemplate: "template6"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "sampling-monitor-report",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "sampling-monitor-report",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "monitor-report-requests",
                        redirect: { name: "monitor-report-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "monitor-report-requests",
                                component: () => import("../views/app/sampling-monitor/sampling-monitor/SamplingMonitorList"),
                                columnTemplate: "template2"
                            },
                            {
                                path: ":id/view",
                                name: "monitor-report-requests-view",
                                component: () => import("../views/app/sampling-monitor/sampling-monitor/SamplingMonitorForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "monitor-report-products",
                        redirect: { name: "monitor-report-products" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "monitor-report-products",
                                component: () => import("../views/app/sampling/sampling-product/SamplingProductList"),
                                props: {
                                    refSamplingRequestTypeKey: ["M"],
                                    columnTemplate: "template4"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: "calendars",
                redirect: { name: "calendars" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "calendars",
                        component: () => import("../views/app/calendar/Calendar")
                    }
                ]
            }
        ]
    },
    {
        path: "/account",
        name: "account",
        redirect: { name: "login" },
        meta: { isPublic: true },
        component: () => import("../components/layout/account-layout/AccountLayout"),
        children: [
            {
                path: "login",
                name: "login",
                meta: { isPublic: true },
                component: () => import("../views/account/login/Login")
            },
            {
                path: "forgot-password",
                name: "forgot-password",
                meta: { isPublic: true },
                component: () => import("../views/account/login/ForgotPassword")
            },
            {
                path: "active-forgot-password",
                name: "active-forgot-password",
                meta: { isPublic: true },
                component: () => import("../views/account/login/ActiveForgotPassword")
            }
        ]
    },
    {
        path: "/register",
        name: "register",
        meta: { isPublic: true },
        component: () => import("../views/account/login/Register")
    },
    {
        path: "/403",
        name: "403",
        meta: { isPublic: true },
        component: () => import("../views/error/403")
    },
    {
        path: "/500",
        name: "500",
        meta: { isPublic: true },
        component: () => import("../views/error/500")
    },
    {
        path: "/:pathMatch(.*)*",
        name: "404",
        meta: { isPublic: true },
        component: () => import("../views/error/404")
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routeData
});

const clearCacheQuery = (to, from, roleMenus) => {
    const menuContext = matchMenu(from.path, roleMenus);
    if (menuContext && menuContext.query) {
        if (menuContext.query.cacheQuery !== "true") {
            menuContext.query = null;
        }
    }
};

router.beforeEach((to, from, next) => {
    let allow = false;
    if (to.meta.isPublic) {
        allow = true;
    }
    if (to?.path !== from?.path) {
        setIsLoading(true);
    }
    const getRoleMenu = ref(null);
    const isAuth = store.getters["resource/auth/isAuth"];
    if (to.meta.isAuth && isAuth) {
        allow = true;
    }
    if (isAuth) {
        getRoleMenu.value = store.dispatch("resource/auth/getInfo", {});
        store.dispatch("resource/auth/setIntervalLogout", {});
    } else {
        getRoleMenu.value = store.dispatch("resource/anonymous/getInfo", {});
    }
    getRoleMenu.value
        .then(info => {
            stateApp.authInfo = info;
            const roleMenus = info.menus;
            clearCacheQuery(to, from, roleMenus);
            const match = matchMenu(to.path, roleMenus);
            stateApp.menuContext = match;
            stateApp.isChangePage = true;
            if (allow) {
                next();
            } else if (!match) {
                if (isAuth) {
                    next({ name: "403", query: { url: from.fullPath } });
                } else {
                    next({ name: "login", query: { url: to.fullPath } });
                }
            } else {
                if (Object.keys(to.query).length > 0) {
                    match.query = to.query;
                }
                next();
            }
        })
        .finally(() => {
            clearModal();
            setTimeout(() => {
                setIsLoading(false, 500);
                stateApp.isChangePage = false;
            });
        });
});

export { router as default, routeData };
